module.exports = __webpack_public_path__ + "static/media/press_content_02.9bc8428f.png";